import { CrudList } from '../shared/CrudPage';
import { featureService } from '@kss/api';
import type { Feature, FeatureCreate, FeatureFilter } from '@kss/api';

/**
 * Features grid — wired to the live `Feature` shape verified in
 * `packages/api/src/data/feature.ts`. The live API field is `module`
 * (e.g. "Auth", "Billing", "Inventory"); the legacy `category` is
 * never populated on real rows.
 *
 * `isActive` is also absent on the live schema (Features are global,
 * not per-tenant toggleable) — removed so the column doesn't sit
 * empty next to every row.
 *
 * Bug ref: AI Agent (round 3) — "Features: category column showing
 * blank in table and category field missing in form."
 */
export default function AllFeatures() {
  return (
    <CrudList<Feature, FeatureCreate, FeatureFilter>
      title="All features" newLabel="New feature" service={featureService}
      idKey="featureId" labelKey="name" basePath="/panel/features"
      columns={[
        { accessor: 'code', title: 'Code', sortable: true, filterable: true, width: 160 },
        { accessor: 'name', title: 'Name', sortable: true, filterable: true },
        { accessor: 'module', title: 'Module', sortable: true, filterable: true,
          render: (r) => r.module || r.category || '—' },
        { accessor: 'description', title: 'Description', render: (r) => r.description || '—' },
      ]}
    />
  );
}
